/** タイムラインの座標と目盛（索引 Issue #498 の段階 5）。純関数 */
export const ZOOM_STEPS = [2, 5, 10, 20, 40, 80, 160, 320];
export const DEFAULT_ZOOM = 40;   // 1 秒あたりの px
export const SNAP_PX = 8;
export const LANE_H = 34;

export const msToX = (ms, pxPerSec) => (ms / 1000) * pxPerSec;
export const xToMs = (x, pxPerSec) => (x / pxPerSec) * 1000;

export function zoomBy(zoom, dir) {
  const i = ZOOM_STEPS.indexOf(zoom);
  const at = i < 0 ? ZOOM_STEPS.indexOf(DEFAULT_ZOOM) : i;
  return ZOOM_STEPS[Math.min(ZOOM_STEPS.length - 1, Math.max(0, at + dir))];
}

/** ラベルが `minPx` 以上離れる最小の刻み */
export function tickStepMs(pxPerSec, minPx = 70) {
  const steps = [100, 200, 500, 1000, 2000, 5000, 10000, 30000, 60000, 300000];
  return steps.find((ms) => msToX(ms, pxPerSec) >= minPx) ?? steps[steps.length - 1];
}

export function formatClock(ms) {
  const t = Math.max(0, Math.round(ms));
  const m = Math.floor(t / 60000);
  const s = Math.floor(t / 1000) % 60;
  const cs = Math.floor((t % 1000) / 10);
  return `${m}:${String(s).padStart(2, '0')}.${String(cs).padStart(2, '0')}`;
}

/** 近くの吸着先（帯の端・再生位置・イン/アウト・マーカー）へ寄せる */
export function snapMs(ms, candidates = [], pxPerSec, snapPx = SNAP_PX) {
  let best = null;
  let bestDist = Infinity;
  for (const c of candidates) {
    if (!Number.isFinite(c)) continue;
    const d = Math.abs(msToX(ms - c, pxPerSec));
    if (d < bestDist) { bestDist = d; best = c; }
  }
  return bestDist <= snapPx ? best : ms;
}

/**
 * 重なる帯を**必要な数だけ**段に分ける（貪欲。開始の早い順に、空いている一番上の段へ）。
 * 1 段に詰めると、同じ時間に重なった演出が互いを隠してしまう。
 * @returns `{ rows: Map(id → 段), count: 段の数（最低 1） }`
 */
export function stackRows(objects = []) {
  const sorted = [...objects].sort((a, b) => a.startMs - b.startMs || a.endMs - b.endMs);
  const ends = [];
  const rows = new Map();
  for (const o of sorted) {
    let row = ends.findIndex((end) => end <= o.startMs);
    if (row < 0) { row = ends.length; ends.push(0); }
    ends[row] = o.endMs;
    rows.set(o.id, row);
  }
  return { rows, count: Math.max(1, ends.length) };
}
